var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 10.6668C4.89527 10.6668 3.99984 11.5623 3.99984 12.6668C3.99984 13.035 4.29831 13.3335 4.6665 13.3335H11.3332C11.7014 13.3335 11.9998 13.035 11.9998 12.6668C11.9998 11.5623 11.1044 10.6668 9.99984 10.6668H5.99984ZM2.6665 12.6668C2.6665 10.8259 4.15889 9.3335 5.99984 9.3335H9.99984C11.8408 9.3335 13.3332 10.8259 13.3332 12.6668C13.3332 13.7714 12.4377 14.6668 11.3332 14.6668H4.6665C3.56193 14.6668 2.6665 13.7714 2.6665 12.6668Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 2.66683C6.89527 2.66683 5.99984 3.56226 5.99984 4.66683C5.99984 5.7714 6.89527 6.66683 7.99984 6.66683C9.10441 6.66683 9.99984 5.7714 9.99984 4.66683C9.99984 3.56226 9.10441 2.66683 7.99984 2.66683ZM4.6665 4.66683C4.6665 2.82588 6.15889 1.3335 7.99984 1.3335C9.84079 1.3335 11.3332 2.82588 11.3332 4.66683C11.3332 6.50778 9.84079 8.00016 7.99984 8.00016C6.15889 8.00016 4.6665 6.50778 4.6665 4.66683Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.4b1a1f61a91d58cf70238c0301220634.svg";
export { ForwardRef as ReactComponent };